export default __webpack_public_path__ + "static/media/axsushi.6508b95b.svg";